import './ProjectDetail.css'

import loc from '../../assets/location-icon.svg'

function ProjectDetail({ name, description, location, images }) {
    return(
        <article className='detail-card'>
            <section className='section'>
                <p className='detail-card-title'>{name}</p>
                <p className='detail-card-subtitle'>{description}</p>
                <img src={loc} alt='location' className='location-icon'/>
                <p className='detail-card-subtitle'>{location}</p>
            </section>
            <picture>
                {images.map((image, index) => (
                    <img 
                        key={index} 
                        src={image} 
                        alt={name} 
                        className='detail-card-img'
                    />
                ))}
            </picture>
        </article>
    )
}

export default ProjectDetail